import { ProtectedRoute } from 'auth/ProtectedRoute';
import { AppError } from 'components/AppError';
import { HomeSettings } from 'pages/HomeSettings';
import { MainLayout } from 'layouts/MainLayout';
import { About } from 'pages/About';
import { Account } from 'pages/Account';
import { AccountVerification } from 'pages/AccountVerification';
import { EmailChange } from 'pages/EmailChange';
import { Energy } from 'pages/Energy';
import { Eula } from 'pages/Eula';
import { ForgottenPassword } from 'pages/ForgottenPassword';
import { Light } from 'pages/Light';
import { Login } from 'pages/Login/Login';
import { MainLights } from 'pages/MainLights';
import { PresetDetails } from 'pages/PresetDetails';
import { Registration } from 'pages/Registration';
import { ResetPassword } from 'pages/ResetPassword';
import { Room } from 'pages/Room';
import { Sensors } from 'pages/Sensors';
import { Shades } from 'pages/Shades';
import { SupportTicket } from 'pages/SupportTicket';
import { Temperature } from 'pages/Temperature';
import { AwayPage } from 'pages/Temperature/Away';
import { SchedulePage } from 'pages/Temperature/Schedule';
import { ThermostatPage } from 'pages/Temperature/Thermostat';
import { VerifyEmailChange } from 'pages/VerifyEmailChange';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { BaseLayout } from './layouts/BaseLayout';
import { Home } from './pages/Home';

export const router = createBrowserRouter(
  [
    {
      element: <BaseLayout />,
      children: [
        {
          element: <MainLayout />,
          errorElement: <AppError />,
          children: [
            {
              path: '/',
              element: (
                <ProtectedRoute>
                  <Navigate to="/home" />
                </ProtectedRoute>
              ),
            },
            {
              path: 'home',
              element: (
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              ),
            },
            {
              path: 'home-settings',
              element: (
                <ProtectedRoute>
                  <HomeSettings />
                </ProtectedRoute>
              ),
            },
            {
              path: 'room/:roomId',
              element: (
                <ProtectedRoute>
                  <Room />
                </ProtectedRoute>
              ),
            },
            {
              path: 'room/:roomId/lighting/:lightId',
              element: (
                <ProtectedRoute>
                  <Light />
                </ProtectedRoute>
              ),
            },
            {
              path: 'room/:roomId/lights-group/:groupId',
              element: (
                <ProtectedRoute>
                  <MainLights />
                </ProtectedRoute>
              ),
            },
            {
              path: 'room/:roomId/lights-group/:groupId/preset/:presetId',
              element: (
                <ProtectedRoute>
                  <PresetDetails />
                </ProtectedRoute>
              ),
            },
            {
              path: 'room/:roomId/sensors/:sensorsId',
              element: (
                <ProtectedRoute>
                  <Sensors />
                </ProtectedRoute>
              ),
            },
            {
              path: 'room/:roomId/shades/:parentShadesId',
              element: (
                <ProtectedRoute>
                  <Shades />
                </ProtectedRoute>
              ),
            },
            {
              path: 'room/:roomId/temperature/:temperatureThingId',
              element: (
                <ProtectedRoute>
                  <Temperature />
                </ProtectedRoute>
              ),
              children: [
                {
                  path: 'thermostat',
                  element: <ThermostatPage />,
                },
                {
                  path: 'schedule',
                  element: <SchedulePage />,
                },
                {
                  path: 'away',
                  element: <AwayPage />,
                },
              ],
            },
            {
              path: 'energy',
              element: (
                <ProtectedRoute>
                  <Energy />
                </ProtectedRoute>
              ),
            },
            {
              path: 'account',
              element: (
                <ProtectedRoute>
                  <Account />
                </ProtectedRoute>
              ),
            },
            {
              path: 'account/about',
              element: (
                <ProtectedRoute>
                  <About />
                </ProtectedRoute>
              ),
            },
            {
              path: 'account/eula',
              element: (
                <ProtectedRoute>
                  <Eula />
                </ProtectedRoute>
              ),
            },
            {
              path: 'account/support/createTicket/:id',
              element: (
                <ProtectedRoute>
                  <SupportTicket />
                </ProtectedRoute>
              ),
            },
            {
              path: 'account/email',
              element: (
                <ProtectedRoute>
                  <EmailChange />
                </ProtectedRoute>
              ),
            },
            {
              path: 'account/email/verify',
              element: (
                <ProtectedRoute>
                  <VerifyEmailChange />
                </ProtectedRoute>
              ),
            },
            { path: 'register', element: <Registration /> },
            { path: 'verify-account', element: <AccountVerification /> },
            { path: 'forgot-password', element: <ForgottenPassword /> },
            { path: 'reset-password/:email', element: <ResetPassword /> },
          ],
        },
        { path: 'login', element: <Login /> },
      ],
    },
  ],
  {
    basename: process.env.PUBLIC_URL,
  },
);
